import { __extends } from "tslib";
import React from 'react';
import { withDimensions } from '../../../../components/withDimensions';
import { sizeClassName } from '../../classNameStrategies';
export default function videoComponentWrapper(ExternalComponent) {
    var _a;
    return withDimensions((_a = /** @class */ (function (_super) {
            __extends(VideoComponentWrapper, _super);
            function VideoComponentWrapper(props) {
                var _this = _super.call(this, props) || this;
                _this.handleFilesAdded = function (data) {
                    _this.props.store.update('componentData', { data: data });
                };
                if (props.store) {
                    props.store.set('handleFilesAdded', _this.handleFilesAdded.bind(_this));
                }
                return _this;
            }
            VideoComponentWrapper.prototype.render = function () {
                var _a = this.props, _b = _a.componentData, config = _b.config, data = _b.data, width = _a.width;
                return React.createElement(ExternalComponent, { config: config, data: data, width: width });
            };
            return VideoComponentWrapper;
        }(React.Component)),
        _a.sizeClassName = function (componentData, theme, styles, isMobile) {
            return sizeClassName(componentData, theme, styles, isMobile);
        },
        _a));
}
//# sourceMappingURL=video-component-wrapper.js.map